module.exports = __webpack_public_path__ + "img/pe_yes.9fc3e27e.png";